import { useContext } from "react";
import { PageContext } from "contexts";

export default () => useContext(PageContext);
